import React from "react";
import { GalleryImageCard } from "./features/gallery/GalleryImageCard";
import { useModal } from "./components/ModalProvider";
import { OurVineyardModal } from "./features/gallery/OurVineyardModal";
import { OurGardensModal } from "./features/gallery/OurGardensModal";
import { BookEventModal } from "./features/gallery/BookEventModal";

export const LandingPage = () => {
  const { openModal } = useModal();

  return (
    <>
      <section className="navbar">
        <div className="sticle-logo"></div>
        <nav>
          <ul>
            <li>
              <a href="#discover-sticle">HOME</a>
            </li>
            <li>
              <a href="#our-vineyard">OUR VINEYARD</a>
            </li>
            <li>
              <a href="#our-vines">OUR VINES</a>
            </li>
            <li>
              <a href="#our-location">OUR LOCATION</a>
            </li>
          </ul>
        </nav>
      </section>

      <section id="discover-sticle" className="content-section">
        <div className="content-section-title">
          <h3 className="subtitle">ESTABLISHED 2019</h3>
          <h1 className="header">DISCOVER STICLE VINEYARD</h1>
          <div className="sticle-video">
            <video width="100%" height="100%" controls>
              <source
                src="https://sticlevineyard.s3.eu-west-2.amazonaws.com/images/brochure/Sticle+Vineyard+2.mov"
                type="video/mp4"
              />
              Your browser does not support video.
            </video>
          </div>
        </div>
        <div className="content-section-background-image"></div>
      </section>

      <section id="our-vineyard" className="content-section">
        <div className="content-section-title">
          <h3 className="subtitle">STICLE VINEYARD</h3>
          <h1 className="header">OUR STORY</h1>
          <p className="w-full">
            <strong>Sticle Vineyard</strong> was established in 2019. Located in Pencader,
            Carmarthenshire, it is one of Southwest Wales's most significant sustainable, organic
            and regenerative wine estate with 10,000 vines of Chardonnay, Pinot Noir, and Pinot
            Meunier.
          </p>
          <p className="w-full mt-4">
            Sticle Vineyard is a member of WineGB. It respects the environment and supports its
            local economy with employment.
          </p>
          <p className="w-full mt-4">
            The Vintner Business is so much more today, considering the many challenges with Climate
            Change and Sustainability issues – to always try do the right thing – and for those
            reasons, its owner, Christiane Racine, has extensively invested her time in the last six
            years with the UN Global Compact and the Welsh Government initiatives in the Food &
            Drinks Cluster, Sustainability Cluster and the Wine Cluster for delivering the
            strategies required to grow the Welsh Wine Industry.
          </p>
        </div>
        <div className="vineyard-content">
          <div className="cards">
            <div
              className="card"
              id="showbox-our-gardens"
              onClick={() => openModal(<OurVineyardModal />)}
            >
              <GalleryImageCard imageUrl="https://sticlevineyard.s3.eu-west-2.amazonaws.com/images/brochure/b4.JPG" />
              <span className="title">OUR VINEYARD</span>
            </div>
            <div
              className="card"
              id="showbox-our-vines"
              onClick={() => openModal(<OurGardensModal />)}
            >
              <GalleryImageCard imageUrl="https://sticlevineyard.s3.eu-west-2.amazonaws.com/images/brochure/i57.JPG" />
              <div
                className="image"
                style={{
                  backgroundImage:
                    "linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 1)), url('https://sticlevineyard.s3.eu-west-2.amazonaws.com/images/carousel/our_vines_1.jpg')"
                }}
              ></div>
              <span className="title">OUR WILD GARDENS</span>
            </div>
            <a
              href="https://www.airbnb.co.uk/rooms/875358973304320074"
              target="_blank"
              rel="noopener noreferrer"
              className="card"
            >
              <GalleryImageCard imageUrl="https://sticlevineyard.s3.eu-west-2.amazonaws.com/images/brochure/d12.JPG" />
              <span className="title">
                <svg xmlns="http://www.w3.org/2000/svg" width="80" height="40" viewBox="0 0 120 60">
                  <path
                    d="M63.042 21.358a2.264 2.264 0 1 1-2.264-2.264 2.257 2.257 0 0 1 2.264 2.264zm-9.34 4.55v.56a4.353 4.353 0 0 0-3.369-1.395 6.671 6.671 0 0 0-6.739 6.9 6.671 6.671 0 0 0 6.732 6.907 4.232 4.232 0 0 0 3.369-1.429v.593a.478.478 0 0 0 .485.485h2.824V25.4h-2.8a.499.499 0 0 0-.485.485zm0 8.396a3.464 3.464 0 0 1-2.824 1.429c-2.23 0-3.935-1.395-3.935-3.76s1.705-3.76 3.935-3.76a3.558 3.558 0 0 1 2.824 1.429v4.67zm5.4-8.882h3.37v13.1h-3.37V25.4zm49.967-.35a4.353 4.353 0 0 0-3.369 1.395v-7.352h-3.37V38.52h2.823a.499.499 0 0 0 .485-.485v-.593A4.313 4.313 0 0 0 109 38.871a6.691 6.691 0 0 0 6.739-6.9 6.685 6.685 0 0 0-6.739-6.9zM108.5 35.7a3.41 3.41 0 0 1-2.824-1.429V29.6a3.78 3.78 0 0 1 2.824-1.429c2.23 0 3.935 1.395 3.935 3.76s-1.705 3.76-3.935 3.76zm-7.878-4.946v7.803h-3.37v-7.413c0-2.163-.674-3.032-2.58-3.032a3.74 3.74 0 0 0-2.695 1.287v9.124h-3.37V25.4h2.648a.499.499 0 0 1 .485.485v.56a4.798 4.798 0 0 1 3.551-1.395 5.391 5.391 0 0 1 3.659 1.253c1.186.977 1.637 2.23 1.637 4.427zm-20.1-5.68a4.353 4.353 0 0 0-3.369 1.395v-7.352h-3.37V38.52h2.824a.499.499 0 0 0 .485-.485v-.593a4.313 4.313 0 0 0 3.369 1.429 6.691 6.691 0 0 0 6.739-6.9 6.644 6.644 0 0 0-6.739-6.9zM79.96 35.7a3.41 3.41 0 0 1-2.824-1.429V29.6a3.78 3.78 0 0 1 2.824-1.429c2.23 0 3.935 1.395 3.935 3.76s-1.705 3.76-3.935 3.76zm-9.08-10.63a5.344 5.344 0 0 1 1.536.175v3.1s-2.8-.923-4.528 1.044v9.165h-3.37V25.4h2.824a.499.499 0 0 1 .485.485v.56a4.576 4.576 0 0 1 3.032-1.395zM36.14 37.335l-.526-1.253-.802-1.78-.034-.034a359.93 359.93 0 0 0-7.696-15.748l-.108-.2-.83-1.67a10.02 10.02 0 0 0-1.253-1.914 5.627 5.627 0 0 0-4.461-2.129 5.849 5.849 0 0 0-4.461 2.089 12.015 12.015 0 0 0-1.253 1.914l-.943 1.846c-2.695 5.23-5.297 10.52-7.702 15.748l-.034.067c-.2.573-.485 1.16-.768 1.786q-.263.573-.526 1.253a7.83 7.83 0 0 0-.418 3.76 7.413 7.413 0 0 0 4.528 5.782 7.156 7.156 0 0 0 2.824.559 7.911 7.911 0 0 0 .903-.067 9.205 9.205 0 0 0 3.484-1.186 17.642 17.642 0 0 0 4.319-3.625 18.302 18.302 0 0 0 4.319 3.625 9.198 9.198 0 0 0 3.484 1.186 7.925 7.925 0 0 0 .903.067 7.042 7.042 0 0 0 2.824-.559 7.413 7.413 0 0 0 4.528-5.782 6.584 6.584 0 0 0-.317-3.726zm-15.708 1.813c-1.88-2.372-3.1-4.596-3.518-6.483a5.62 5.62 0 0 1-.108-2.123 3.369 3.369 0 0 1 .559-1.462 3.7 3.7 0 0 1 3.066-1.536 3.565 3.565 0 0 1 3.066 1.53 3.369 3.369 0 0 1 .559 1.462 5.6 5.6 0 0 1-.108 2.123c-.418 1.846-1.637 4.043-3.518 6.483zm13.902 1.637a5.175 5.175 0 0 1-3.174 4.043 5.276 5.276 0 0 1-2.642.384 6.853 6.853 0 0 1-2.648-.903 16.274 16.274 0 0 1-3.969-3.369c2.298-2.824 3.693-5.4 4.218-7.702a8.76 8.76 0 0 0 .175-2.965 5.654 5.654 0 0 0-.943-2.372 5.869 5.869 0 0 0-4.919-2.5 5.964 5.964 0 0 0-4.912 2.473 5.654 5.654 0 0 0-.943 2.372 7.237 7.237 0 0 0 .175 2.965c.526 2.298 1.954 4.912 4.218 7.736a15.654 15.654 0 0 1-3.969 3.369 6.853 6.853 0 0 1-2.655.93 5.573 5.573 0 0 1-2.648-.35 5.175 5.175 0 0 1-3.174-4.043 5.768 5.768 0 0 1 .317-2.695c.108-.35.276-.674.45-1.112.243-.56.526-1.152.802-1.745l.034-.067c2.406-5.2 4.98-10.485 7.67-15.647l.1-.25.836-1.604a7.642 7.642 0 0 1 1.004-1.543 3.659 3.659 0 0 1 5.573 0 7.655 7.655 0 0 1 .95 1.53l.836 1.604.1.2c2.648 5.196 5.236 10.485 7.635 15.68v.034c.276.56.526 1.186.802 1.745.175.418.35.768.45 1.112a5.883 5.883 0 0 1 .243 2.695z"
                    fill="#ff5a5f"
                    fillRule="evenodd"
                  />
                </svg>
                BOOK A LUXURIOUS VINEYARD STAY
                <br />
                <small className="text-slate-200">TOP 1% OF HOMES</small>
              </span>
            </a>
            <div className="card" onClick={() => openModal(<BookEventModal />)}>
              <GalleryImageCard imageUrl="https://sticlevineyard.s3.eu-west-2.amazonaws.com/images/book_event_1.PNG" />
              <span className="title">BOOK AN EVENT</span>
            </div>
          </div>
        </div>
      </section>

      <section id="our-vines" className="content-section">
        <div className="content-section-title">
          <h3 className="subtitle">THE HEART OF THE VINEYARD</h3>
          <h1 className="header">OUR VINES</h1>
          <p>
            Sticle Vineyard is home to over 10,000 vines, growing on 25 acres of beautiful land. The
            family owned vineyard was established in 2019 and will be limited to 10,000 bottles of
            each of its 3 Cuvée, so not to overwork its vines.
          </p>
        </div>
        <div className="vines-content">
          <div className="vines-image">
            <img
              src="https://sticlevineyard.s3.eu-west-2.amazonaws.com/images/white-grape.png"
              alt="image of white grapes"
            />
          </div>
          <div className="vines-breakdown">
            <div className="vine-breakdown">
              <h3 className="subtitle">3,400 VINES</h3>
              <p className="header vine-name">CHARDONNAY</p>
            </div>
            <div className="vine-breakdown">
              <h3 className="subtitle">3,300 VINES</h3>
              <p className="header vine-name">PINOT NOIR</p>
            </div>
            <div className="vine-breakdown">
              <h3 className="subtitle">3,300 VINES</h3>
              <p className="header vine-name">PINOT MEUNIER</p>
            </div>
          </div>
        </div>
      </section>

      <section id="our-location" className="content-section">
        <div className="content-section-title">
          <h3 className="subtitle">BEAUTIFULLY NESTLED IN SOUTH WEST WALES</h3>
          <h1 className="header">OUR LOCATION</h1>
        </div>
        <div className="content-section-background-image"></div>
        <div className="location-content">
          <div id="map" className="maps-container">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d17909.890768727986!2d-4.277241323390221!3d52.00298575669548!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xba48bb3c8bc6edc6!2sSticle%20Vineyard!5e1!3m2!1sen!2suk!4v1572185655078!5m2!1sen!2suk"
              width="100%"
              height="100%"
              frameBorder="0"
              style={{ border: 0 }}
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </section>

      <section className="footer">
        <div className="footer-content">
          <div className="footer-copy">
            <p className="copyright-notice">
              Copyright © 2023 Sticle Vineyard Ltd. All rights reserved.
            </p>
            <p>
              Designed by the Racine Family with ❤️&nbsp;in <br />
              South West Wales, UK.
            </p>
          </div>
          <div className="footer-contact">
            <h2 className="subheader">CONTACT</h2>
            <p>
              Sticle Vineyard
              <br />
              Castle Road
              <br />
              Pencader
              <br />
              Carmarthenshire
              <br />
              SA39 9AN
              <br />
              <br />
              <a href="mailto:enquiry@sticlevineyard.co.uk">enquiry@sticlevineyard.co.uk</a>
            </p>
          </div>
          <div className="footer-links">
            <h2 className="subheader">LINKS</h2>
            <ul>
              <li>
                <a href="#discover-sticle">Home</a>
              </li>
              <li>
                <a href="#our-vineyard">Our vineyard</a>
              </li>
              <li>
                <a href="#our-vines">Our vines</a>
              </li>
              <li>
                <a href="#our-location">Our location</a>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </>
  );
};
